export default __webpack_public_path__ + "static/greview-709d480a6c2dddd4be24998a602f03d0.svg";